export default ({ request }) => ({
  orderBudgetAnalysisGetBudgetYearApi(data = {}) {
    return request({
      url: '/factory/order/budget/analysis/getBudgetYear',
      method: 'post',
      data
    })
  },
  orderBudgetAnalysisListDepApi(data = {}) {
    return request({
      url: '/factory/order/budget/analysis/listDep',
      method: 'post',
      data
    })
  },
  orderBudgetAnalysisListTeamApi(data = {}) {
    return request({
      url: '/factory/order/budget/analysis/listTeam',
      method: 'post',
      data
    })
  },
  orderBudgetAnalysisListTeamCustApi(data = {}) {
    return request({
      url: '/factory/order/budget/analysis/listTeamCust',
      method: 'post',
      data
    })
  },
  orderBudgetAnalysisListSalesApi(data = {}) {
    return request({
      url: '/factory/order/budget/analysis/listSales',
      method: 'post',
      data
    })
  }
})
